import(/* webpackMode: "eager" */ "/opt/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AiChatLauncher"] */ "/opt/app/src/rsc/app-shell/AiChatLauncher.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellEffects"] */ "/opt/app/src/rsc/app-shell/AppShellEffects.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentScripts"] */ "/opt/app/src/rsc/app-shell/ConsentScripts.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadedImages"] */ "/opt/app/src/rsc/app-shell/PreloadedImages.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnchorJumpScript"] */ "/opt/app/src/rsc/client/AnchorJumpScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationMarker"] */ "/opt/app/src/rsc/client/HydrationMarker.tsx");
